const Edit = (props) => {
  const { clubMembershipId } = props;
  return (
    <a
      href={`/profile/club-membership/${clubMembershipId}`}
      className="c7-button"
    >
      Edit Membership
    </a>
  );
};

export default Edit;
